import { render } from "./OpenMobile.vue?vue&type=template&id=0db66ada&scoped=true"
import script from "./OpenMobile.vue?vue&type=script&lang=js"
export * from "./OpenMobile.vue?vue&type=script&lang=js"

import "./OpenMobile.vue?vue&type=style&index=0&id=0db66ada&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db66ada"]])

export default __exports__